import React, { useState, useEffect, useRef, useMemo } from "react";
import {
    X,
    ChevronLeft,
    MoreHorizontal,
    ChevronRight,
    Copy,
    SquareArrowOutUpRight,
    Search,
    Funnel,
    ChevronsUpDown
} from "lucide-react";
import noImage from "../assets/img/brand/noImage.png";
import apiHelper from "../apiHelper";
import { formatDateTime } from "../utils/formateDate";
import { useHistory, useLocation } from "react-router-dom";
import noBrandImage from "../assets/img/brand/no-brand-img.png";
import AlertNotification from "../components/AlertNotification";
import ConfirmDisableModal from "../components/ConfirmDisableModal";

const StockDrawer = ({ stockId,
  setDrawerOpen,
  setSkuDrawerOpen,
  setSelectedRow,
  fallbackModelNumber,
  skuDrawerOpen = false }) => {
    const [stockData, setStockData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [confirmDisableOpen, setConfirmDisableOpen] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const [copied, setCopied] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [instancesDrawerOpen, setInstancesDrawerOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("overview");
    const [currentPage, setCurrentPage] = useState(1);
    const [drawerTab, setDrawerTab] = useState("entity-info");
    const [selectedStockId, setSelectedStockId] = useState(null);
    const [selectedArchiveStockId, setSelectedArchiveStockId] = useState(null);
    const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const [actionFromDrawer, setActionFromDrawer] = useState(false);
    const [imeiSearchInput, setImeiSearchInput] = useState("");
    const [imeiDropdownOpenId, setImeiDropdownOpenId] = useState(null);
    const [selectedStock, setSelectedStock] = useState([]);
    const [tempSelectedStock, setTempSelectedStock] = useState(null);
    const [stockfilterDrawerOpen, setStockfilterDrawerOpen] = useState(false);
    const [pageInView, setPageInView] = useState(1);
    const [brandsData, setBrandsData] = useState([]);
    const [categoriesData, setCategoriesData] = useState([]);
    const [archivedStockData, setArchivedStockData] = useState([]);
    const drawerRef = useRef(null);
    const toolbarRef = useRef(null);
    const tableRef = useRef(null);
    const TYPE_CHIP_WIDTHS = { Device: 72, "Spare Part": 91, "Spare Parts": 91 };
    const CONDITION_L2_WIDTHS = { Pristine: 72, Mint: 72, Activated: 80, "Not Activated": 105, Satisfactory: 93, NA: 72, "Need to Repair": 110 };
    const getConditionL2Width = (value) => {
        if (!value) return undefined;
        const key = Object.keys(CONDITION_L2_WIDTHS).find((k) => k.toLowerCase() === String(value).toLowerCase());
        return key ? CONDITION_L2_WIDTHS[key] : undefined;
    };
    const toggleToolbarDropdown = () => {
        setToolbarDropdownOpen(!toolbarDropdownOpen);
    };

    const handleDeactivateStock = () => {
        console.log("Deactivate stock");
    };
      useEffect(() => {
        async function fetchBrands() {
          try {
            const res = await apiHelper(
              "inventory/brands/?is_archived=false",
              "GET"
            );
    
            const data = await res.json();
            const mapped = data.map((item) => ({
              id: item.brand_id,
              name: item.brand_name,
              image: item.original_logo || noImage,
              status: item.status ? "Active" : "Inactive",
            }));
    
            setBrandsData(mapped);
          } catch (e) {
            console.error("Brand API failed", e);
          }
        }
    
        fetchBrands();
      }, []);
    
      useEffect(() => {
        async function fetchCategories() {
          try {
            const res = await apiHelper(
              "inventory/categories/?is_archived=false",
              "GET"
            );
    
            const data = await res.json();
    
            const mapped = data.map((item) => ({
              id: item.category_id,
              name: item.category_name,
              parent_name: item.parent_name,
              parent_parent_name: item.parent_parent_name,
              parent_category: item.parent_category,
            }));
    
            setCategoriesData(mapped);
          } catch (e) {
            console.error("Category API failed", e);
          }
        }
    
        fetchCategories();
      }, []);
    
    // Drawer -> Stock instances tab data
    const imeiStockData = [
        {
            id: 1,
            imei: "35334107 123456 2",
            location: "Bedok",
            available: 232,
            reserved: 2,
            pending: [
                { type: "Inbounding", color: "#198754", count: 5 },
                { type: "Outbounding", color: "#FD7E14", count: 10 },
                { type: "Transferring", color: "#6C757D", count: 9 },
            ],
        },
        {
            id: 2,
            imei: "35334107 123456 2",
            location: "(Pending)",
            available: 43,
            reserved: 2,
            pending: [
                { type: "Outbounding", color: "#FD7E14", count: 10 },
                { type: "Transferring", color: "#6C757D", count: 9 },
            ],
        },
        {
            id: 3,
            imei: "35334107 123456 2",
            location: "HQ",
            available: 67,
            reserved: 6,
            pending: [{ type: "Inbounding", color: "#198754", count: 5 }],
        },
    ];
    // 1. Filtered & visible rows based on selected branch and global search
    const visibleImeiRows = useMemo(() => {
        let rows = imeiStockData;

        // Filter by selected branch
        if (selectedStock.length > 0) {
            const selectedBranchNames = selectedStock.map((b) => b.value);
            rows = rows.filter((row) => selectedBranchNames.includes(row.location));
        }

        // Filter by search text
        if (imeiSearchInput.trim()) {
            const searchLower = imeiSearchInput.toLowerCase();
            rows = rows.filter((row) =>
                Object.values(row).some((val) =>
                    String(val).toLowerCase().includes(searchLower)
                )
            );
        }

        return rows;
    }, [imeiStockData, imeiSearchInput, selectedStock]);


    const imeiStats = useMemo(() => {
        let reserved = 0;
        let available = 0;
        const pendingTotals = {};

        visibleImeiRows.forEach((row) => {
            reserved += row.reserved || 0;
            available += row.available || 0;

            if (Array.isArray(row.pending)) {
                row.pending.forEach((p) => {
                    if (!pendingTotals[p.type]) {
                        pendingTotals[p.type] = { count: 0, color: p.color };
                    }
                    pendingTotals[p.type].count += p.count || 0;
                });
            }
        });

        return { reserved, available, pendingTotals };
    }, [visibleImeiRows]);

    const PendingInfoTooltip = () => {
        const [tip, setTip] = useState({ show: false, top: 0, left: 0 });
        return (
            <>
                <div
                    style={{ display: "inline-flex", alignItems: "center", cursor: "default", marginLeft: 3 }}
                    onMouseEnter={(e) => {
                        const r = e.currentTarget.getBoundingClientRect();
                        setTip({ show: true, top: r.top, left: r.left + r.width / 2 });
                    }}
                    onMouseLeave={() => setTip(t => ({ ...t, show: false }))}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <g clipPath="url(#pending_info_clip_sd)">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                            <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.1456 7.39094C4.97372 7.39094 4.91122 7.27031 4.9556 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                            <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                        </g>
                        <defs>
                            <clipPath id="pending_info_clip_sd">
                                <rect width="10" height="10" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                {tip.show && (
                    <div style={{ position: "fixed", top: tip.top, left: tip.left, transform: "translate(-50%, calc(-100% - 8px))", background: "#495057", color: "white", padding: "16px", borderRadius: "8px", zIndex: 9999, minWidth: "300px", whiteSpace: "normal", pointerEvents: "none", fontFamily: "Montserrat", fontSize: "12px", fontWeight: 400, lineHeight: "1.5" }}>
                        <div><strong>Outbounding:</strong> StockInstance outbound generated from Shopee, Lazada and TikTok orders.</div>
                        <div style={{ marginTop: "8px" }}><strong>Outbounding (Others):</strong> StockInstance outbound generated from orders of other channels.</div>
                        <div style={{ width: 0, height: 0, borderRight: "15px solid transparent", borderBottom: "15px solid transparent", borderTop: "15px solid #495057", position: "absolute", borderLeft: "15px solid transparent", left: "50%", top: "98%", transform: "translateX(-50%)" }} />
                    </div>
                )}
            </>
        );
    };

    const fallbackCopyTextToClipboard = (text) => {
        try {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.opacity = "0";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand("copy");
            document.body.removeChild(textArea);

            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } else {
                console.error("Fallback copy failed");
                alert("Failed to copy text. Please copy manually.");
            }
        } catch (err) {
            console.error("Fallback copy error:", err);
            alert("Failed to copy text. Please copy manually.");
        }
    };

    const fetchStockData = async (stockId) => {
        setLoading(true);
        try {
            
                console.log("stcock id from drawer:", stockId);
            const response = await apiHelper(`inventory/stocks/drawer/${stockId}/`, "GET");
            if (response.ok) {
                const stock = await response.json();
                console.log("Fetched stock data:", stock);
                
                // Map the API data to UI format (same as fetchStockInstances)
                const mapApiStockToUi = (item) => {
                    const summary = item.stock_status_summary;

                    return {
                        id: item.stock_id,
                        is_archived: item.is_archived,
                        archived_time: formatDateTime(item.archived_at),
                        archived_at: formatDateTime(item.archived_at),

                        // SPU & SKU
                        name: item.spu_name,
                        variant: item.sku_name,
                        model_number: item.model_number || "",
                        avatar: item.image ? item.image : noImage,
                        sku_code: item.sku_code,
                        openId: item.sku_uuid,
                        sku_notes: item.sku_notes,

                        // Conditions
                        condition: item.condition || "NA",
                        grading: item.condition_type || "NA",

                        // Status
                        status: item.status ? "Active" : "Inactive",

                        // Meta
                        brand: item.brand_hierarchy && item.brand_hierarchy.length > 0
                          ? item.brand_hierarchy.map((b) => b.name).join(" >> ")
                          : (item.brand || ""),
                        category: item.category,
                        type: item.product_type || "NA",
                        set_type: item.set_type || "",

                        // Dates
                        lastModifiedTime: formatDateTime(item.modified_at),
                        createdAt: formatDateTime(item.created_at),
                        createdBy: item.created_by_name,
                        modifiedBy: item.modified_by_name,
                        archivedBy: item.archived_by_name,

                        spu_id: item.spu_id,
                        sku_id: item.sku_id,

                        // UPDATED: Real backend values with FE colors
                        pending: [
                            {
                                type: "Inbounding",
                                color: "#198754",
                                count: summary.pending?.find((s) => s.type === "Inbounding")?.count ?? 0,
                            },
                            {
                                type: "Distributing",
                                color: "#FD7E14",
                                count: summary.pending?.find((s) => s.type === "Distributing")?.count ?? 0,
                            },
                            {
                                type: "Transferring",
                                color: "#2C7BE5",
                                count: summary.pending?.find((s) => s.type === "Transferring")?.count ?? 0,
                            },
                            {
                                type: "Outbounding",
                                color: "#DC3545",
                                count: summary.pending?.find((s) => s.type === "Outbounding")?.count ?? 0,
                            },
                            {
                                type: "Outbounding (others)",
                                color: "#DC3545",
                                count: summary.pending?.find((s) => s.type === "Outbounding (others)")?.count ?? 0,
                            },
                            {
                                type: "Transit (Non Reserved)",
                                color: "#DC3545",
                                count: summary.pending?.find((s) => s.type === "Transit (Non Reserved)")?.count ?? 0,
                            },
                        ],

                        inStock_Sellable: [
                            {
                                type: "In Stock",
                                color: "#198754",
                                count: summary.inStock_Sellable.find((s) => s.type === "In Stock")?.count ?? 0,
                            },
                            {
                                type: "Sellable",
                                color: "#FD7E14",
                                count: summary.inStock_Sellable.find((s) => s.type === "Sellable")?.count ?? 0,
                            },
                        ],

                        reserved: summary.reserved,
                    };
                };

                setStockData(mapApiStockToUi(stock));
            } else {
                const errorData = await response.json();
                throw new Error(errorData.detail || "Failed to fetch stock data");
            }
        } catch (error) {
            setError(error.message);
            setAlertMessage(error.message);
            setAlertType("error");
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
    };

   useEffect(() => {
  if (stockId) {
    fetchStockData(stockId);
  }
}, [stockId]);

    // const handleCloseDrawer = () => {
    //     setSelectedRow(null);
    //     setStockData(null);
    //     setDrawerOpen(false);
    // };

    return (
        <>
            {/* Hide this overlay when the SKU info drawer is stacked on top, so backdrops don't double up */}
            {!skuDrawerOpen && (
                <div
                    className="drawer-overlay main-drawer-overlay"
                    onMouseDown={(e) => {
                        // Outside click closes only this nested drawer and returns to the
                        // previous (parent) drawer; stopPropagation keeps the parent open.
                        e.stopPropagation();
                        setDrawerOpen(false);
                    }}
                />
            )}
            <div className="entity-drawer" ref={drawerRef}>
                <div
                    className="drawer-header"
                    style={{ backgroundColor: "#F8F9FA" }}
                >
                    <div className="d-flex align-items-center gap-1">
                    <button
                        className="back-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            setDrawerOpen(false);
                            // setSelectedRow(null);
                        }}
                        style={{
                            backgroundColor: "transparent",
                            border: "none",
                            padding: 0,
                            margin: 0,
                        }}
                    >
                        <ChevronLeft size={24} />
                    </button>
                    <h3>Stock Info</h3>
                    </div>
                    <button
                        className="close-btn"
                        onClick={() => {
                            setDrawerOpen(false);
                            setSelectedIds((ids) =>
                                ids.filter((id) => id !== stockData)
                            );
                            setStockData(null);
                        }}
                    >
                        <X size={24} />
                    </button>
                </div>
                {/* info drawer */}
                <div
                    className="main-drawer-inner"
                    // style={{ marginTop: "50px" }}
                >
                    <div className="drawer-title d-flex align-items-center justify-content-between">
                        <div
                            className="d-flex align-items-center"
                            style={{ gap: "8px" }}
                        >
                            <img
                                src={stockData?.avatar}
                                alt="avatar"
                                style={{
                                    width: 40,
                                    height: 40,
                                    // borderRadius: 6,
                                    objectFit: "cover",
                                    flexShrink: 0,
                                }}
                            />

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                {/* Title */}
                                <span
                                    style={{
                                        fontFamily: "Montserrat",
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        color: "#212529",
                                        lineHeight: "18px",
                                    }}
                                >
                                    {stockData?.name}
                                </span>

                                {/* Subtitle */}
                                <span
                                    style={{
                                        fontFamily: "Montserrat",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color: "#6C757D",
                                        lineHeight: "16px",
                                    }}
                                >
                                    {stockData?.variant}
                                    {(stockData?.model_number || fallbackModelNumber) ? ` | ${stockData?.model_number || fallbackModelNumber}` : ""}
                                </span>
                            </div>
                        </div>
                        {/* <div className="entities-tab flex-row align-items-center gap-3">
                            <div className="toolbar">
                                <div
                                    className="toolbar-right"
                                    style={{ position: "relative" }}
                                    ref={toolbarRef}
                                >
                                    <button
                                        className="drawer-dots"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleToolbarDropdown();
                                        }}
                                    >
                                        <MoreHorizontal size={18} />
                                    </button>

                                    {toolbarDropdownOpen && (
                                        <div
                                            className="backdrop-cls"
                                            style={{
                                                position: "absolute",
                                                top: 40,
                                                right: 0,
                                                background: "white",
                                                boxShadow: "0px 1px 4px 0px #0000001A",
                                                zIndex: 1000,
                                                minWidth: 200,
                                                borderRadius: 8,
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <div className="btn-align-forall">
                                                <div className="common-for-all">
                                                    <button
                                                        onClick={() => {
                                                            setInstancesDrawerOpen(true);
                                                            setDrawerOpen(false);
                                                            history.push(
                                                                `/inventory/stock/${stockData?.id}/stockInstance`,
                                                                {
                                                                    stock: stockData,
                                                                    activeTab,
                                                                    page: currentPage,
                                                                    tab: drawerTab,
                                                                    reopenDrawer: true,
                                                                    stockId: stockData?.id,
                                                                }
                                                            );
                                                        }}
                                                    >
                                                        View All StockInstances
                                                    </button>
                                                </div>
                                                {stockData && (
                                                    <div className="common-for-all">
                                                        {stockData?.status === "Active" ? (
                                                            <button
                                                                onClick={() => {
                                                                    // Deactivate → open confirmation modal
                                                                    setSelectedStockId(
                                                                        stockData?.id
                                                                    );
                                                                    setDeactivateModalOpen(true);
                                                                    setToolbarDropdownOpen(false);
                                                                    setActionFromDrawer(true);
                                                                }}
                                                            >
                                                                Deactivate
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={() => {
                                                                    // Activate → direct API call
                                                                    handleDeactivateStock(
                                                                        stockData?.id
                                                                    );
                                                                    setToolbarDropdownOpen(false);
                                                                    setActionFromDrawer(true);
                                                                }}
                                                            >
                                                                Activate
                                                            </button>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="common-for-all">
                                                    <button
                                                        className="deactivate-cls"
                                                        onClick={() => {
                                                            setActionFromDrawer(true);
                                                            setSelectedArchiveStockId(
                                                                stockData?.id
                                                            );
                                                            setArchivedModalOpen(true);
                                                            setToolbarDropdownOpen(false);
                                                        }}
                                                    >
                                                        Archive
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div> */}
                    </div>

                    <div className="drawer-tabs">
                        <button
                            className={
                                drawerTab === "entity-info" ? "active" : ""
                            }
                            onClick={() => setDrawerTab("entity-info")}
                        >
                            General
                        </button>
                        <button
                            className={
                                drawerTab === "additional-info" ? "active" : ""
                            }
                            onClick={() => setDrawerTab("additional-info")}
                        >
                            Additional
                        </button>
                    </div>

                    <div className="drawer-content">
                        {drawerTab === "entity-info" && (
                            <div className="tab-panel entity-info-panel">
                                {/*Stock Summary Cards*/}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        marginTop: "16px",
                                    }}
                                >
                                    {/* ================= LEFT CARD ================= */}
                                    <div
                                        style={{
                                            flex: 1,
                                            border: "1px solid #E9ECEF",
                                            borderRadius: "8px",
                                            padding: "12px",
                                            background: "#fff",
                                            boxShadow: "1px 1px 4px #818181ff",
                                            display: "flex",
                                            flexDirection: "column", // ✅ important
                                        }}
                                    >
                                        {/* Title */}
                                        <div
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#212529",
                                                fontFamily: "Montserrat",
                                            }}
                                        >
                                            In Stock Qty
                                        </div>

                                        {/* List pushed to bottom */}
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                fontSize: "12px",
                                                fontFamily: "Montserrat",
                                                marginTop: "auto", // ✅ pushes list to bottom
                                                paddingTop: "8px",
                                            }}
                                        >
                                            {(
                                                stockData?.inStock_Sellable || []
                                            ).filter(item => item.type !== "Sellable").map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {/* Dot */}
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ marginRight: 8, flexShrink: 0 }}>
                                                        <circle cx="4" cy="4" r="3" fill={item.color} />
                                                    </svg>

                                                    {/* Label */}
                                                    <span
                                                        style={{
                                                            color: "#6C757D",
                                                            fontFamily: "Montserrat",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {item.type}
                                                    </span>

                                                    {/* Count */}
                                                    <span
                                                        style={{
                                                            marginLeft: "auto",
                                                            fontWeight: 600,
                                                            color: "#212529",
                                                            fontFamily: "Montserrat",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {item.count}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* ================= RIGHT CARD ================= */}
                                    <div
                                        style={{
                                            flex: 1,
                                            border: "1px solid #E9ECEF",
                                            borderRadius: "8px",
                                            padding: "12px",
                                            background: "#fff",
                                            boxShadow: "1px 1px 4px #818181ff",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                fontSize: "12px",
                                                fontWeight: 600,
                                                marginBottom: "8px",
                                                fontFamily: "Montserrat",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: "#212529",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                <span style={{ display: "inline-flex", alignItems: "center" }}>Pending<PendingInfoTooltip /></span>
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                fontSize: "12px",
                                                fontFamily: "Montserrat",
                                            }}
                                        >
                                            {(stockData?.pending || []).filter(p => !["Inbounding", "Distributing", "Transferring"].includes(p.type)).map(
                                                (p, i) => (
                                                    <div
                                                        key={i}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ marginRight: 6, flexShrink: 0 }}>
                                                            <circle cx="4" cy="4" r="3" fill={p.color} />
                                                        </svg>

                                                        <span style={{ color: "#6C757D" }}>
                                                            {p.type}
                                                        </span>
                                                                                                                <span
                                                            style={{
                                                                marginLeft: "auto",
                                                                fontWeight: 600,
                                                                color: "#212529",
                                                            }}
                                                        >
                                                            {p.count}
                                                        </span>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Basic Info in info drawer */}
                                {/* Title */}
                                <div
                                    style={{
                                        marginTop: "20px",
                                        border: "1px solid #E9ECEF",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        background: "#fff",
                                    }}
                                >
                                    {/* Header */}
                                    <div
                                        style={{
                                            backgroundColor: "#F8F9FA",
                                            padding: "15px 20px",
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: "#212529",
                                        }}
                                    >
                                        Basic Info
                                    </div>

                                    {/* Body */}
                                    <div
                                        style={{
                                            padding: "16px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                columnGap: 24,
                                                rowGap: 20,
                                                fontSize: 12,
                                                color: "#212529",
                                            }}
                                        >
                                            {/* SPU & SKU */}
                                            <div style={{ gridColumn: "1 / -1" }}>
                                            <div
                                                style={{
                                                    fontWeight: 700,
                                                    marginBottom: 6,
                                                }}
                                            >
                                                SPU & SKU
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 6,
                                                    minWidth: 0,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {/* Avatar */}
                                                <img
                                                    src={stockData?.avatar}
                                                    alt=""
                                                    style={{
                                                        width: 32,
                                                        height: 32,
                                                        borderRadius: 4,
                                                        flexShrink: 0,
                                                    }}
                                                />

                                                {/* Text */}
                                                <span
                                                    style={{
                                                        color: "#0D6EFD",
                                                        fontWeight: 600,
                                                        cursor: "pointer",
                                                        textDecoration: "underline",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        minWidth: 0,
                                                        fontSize: 12
                                                        // flex: 1, // allows shrinking
                                                    }}
                                                    title={`${stockData?.name} ${stockData?.variant}${stockData?.model_number ? ` · ${stockData.model_number}` : ""}`}
                                                    onClick={(e) => {
                                                        setSelectedRow(stockData); // pass full row
                                                        setSkuDrawerOpen(true);
                                                    }}
                                                >
                                                    {stockData?.name}{" "}
                                                    {stockData?.variant}
                                                    {(stockData?.model_number || fallbackModelNumber) ? ` · ${stockData?.model_number || fallbackModelNumber}` : ""}
                                                </span>

                                                {/* External link icon */}
                                                <SquareArrowOutUpRight
                                                    size={14}
                                                    strokeWidth={2}
                                                    style={{
                                                        color: "#0D6EFD",
                                                        cursor: "pointer",
                                                        flexShrink: 0,
                                                    }}
                                                    onClick={(e) => {
                                                        setSelectedRow(stockData); // pass full row
                                                        setSkuDrawerOpen(true);
                                                    }}
                                                />
                                            </div>
                                            </div>

                                            {/* Condition L1 */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Condition L1
                                                </div>
                                                <span
                                                    style={{
                                                        background: "#FFE70E",
                                                        borderRadius: "999px",
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        whiteSpace: "nowrap",
                                                        width: 72,
                                                        height: 20,
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    {stockData?.condition}
                                                </span>
                                            </div>

                                            {/* Condition L2 */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Condition L2
                                                </div>
                                                <span
                                                    style={{
                                                        background: "#FFE70E",
                                                        borderRadius: "999px",
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        whiteSpace: "nowrap",
                                                        height: 20,
                                                        boxSizing: "border-box",
                                                        ...(getConditionL2Width(stockData?.grading) ? { width: getConditionL2Width(stockData?.grading) } : {}),
                                                    }}
                                                >
                                                    {stockData?.grading}
                                                </span>
                                            </div>

                                            {/* Status */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Status
                                                </div>
                                                <span
                                                    style={{
                                                        width: 72,
                                                        height: 20,
                                                        boxSizing: "border-box",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        padding: "2px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        backgroundColor:
                                                            stockData?.status === "Active"
                                                                ? "#D1FADF"
                                                                : "#FEE4E2",
                                                        color:
                                                            stockData?.status === "Active"
                                                                ? "#027A48"
                                                                : "#B42318",
                                                        border:
                                                            stockData?.status === "Active"
                                                                ? "1px solid #027A48"
                                                                : "1px solid #B42318",
                                                    }}
                                                >
                                                    {stockData?.status}
                                                </span>
                                            </div>

                                            {/* Brand */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Brand
                                                </div>
                                                <div>{stockData?.brand}</div>
                                            </div>

                                            {/* Category */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Category
                                                </div>
                                                <div>{stockData?.category}</div>
                                            </div>

                                            {/* Type */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Type
                                                </div>
                                                <span
                                                    style={{
                                                        backgroundColor: "#FFE84D",
                                                        borderRadius: "999px",
                                                        padding: "5px 10px",
                                                        fontWeight: 600,
                                                        fontSize: 12,
                                                        color: "#212529",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        whiteSpace: "nowrap",
                                                        height: 20,
                                                        boxSizing: "border-box",
                                                        ...(TYPE_CHIP_WIDTHS[stockData?.type] ? { width: TYPE_CHIP_WIDTHS[stockData?.type] } : {}),
                                                    }}
                                                >
                                                    {stockData?.type}
                                                </span>
                                            </div>

                                            {/* Set Type */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Set Type
                                                </div>
                                                <span
                                                    style={{
                                                        background: "#FFE70E",
                                                        padding: "5px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        width: 72,
                                                        height: 20,
                                                        boxSizing: "border-box",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    {stockData?.set_type || "None"}
                                                </span>
                                            </div>

                                            {/* ID */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    ID
                                                </div>
                                                <div>{stockData?.id}</div>
                                            </div>

                                            {/* Open ID */}
                                            <div style={{ gridColumn: "1 / -1" }}>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Open ID
                                                </div>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 6,
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {/* Open ID text */}
                                                    <span
                                                        style={{
                                                            color: "#0D6EFD",
                                                            cursor: "pointer",
                                                            textDecoration: "underline",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            maxWidth: 420, // keeps single line
                                                            flexShrink: 1,
                                                            fontWeight: 500,
                                                            fontSize: 12
                                                        }}
                                                        title={stockData?.openId || "—"}
                                                        onClick={() => {
                                                            // navigator.clipboard.writeText(stockData?.openId);
                                                            navigator.clipboard.writeText(
                                                                stockData?.openId || "—"
                                                            );
                                                            setCopied(true);
                                                            setTimeout(
                                                                () => setCopied(false),
                                                                1500
                                                            );
                                                        }}
                                                    >
                                                        {/* {stockData?.openId} */}
                                                        {stockData?.openId || "—"}
                                                    </span>

                                                    {/* Copy icon + tooltip anchor */}
                                                    <span
                                                        style={{
                                                            position: "relative", // ✅ anchor for tooltip
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            flexShrink: 0,
                                                        }}
                                                        onClick={() => {
                                                            // navigator.clipboard.writeText(stockData?.openId);
                                                            navigator.clipboard.writeText(
                                                                stockData?.openId || "—"
                                                            );
                                                            setCopied(true);
                                                            setTimeout(
                                                                () => setCopied(false),
                                                                1500
                                                            );
                                                        }}
                                                    >
                                                        <Copy
                                                            size={14}
                                                            style={{
                                                                color: "#0D6EFD",
                                                                cursor: "pointer",
                                                            }}
                                                        />

                                                        {/* ✅ Tooltip (NOT clipped now) */}
                                                        {copied && (
                                                            <span
                                                                style={{
                                                                    fontSize: 12,
                                                                    color: "#0D6EFD",
                                                                    fontWeight: 500,
                                                                    marginLeft: 4,
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                Copied!
                                                            </span>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Created By */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Created By
                                                </div>
                                                <div>
                                                    {stockData?.createdBy || "NA"}
                                                </div>
                                            </div>

                                            {/* Created Time */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Created Time
                                                </div>
                                                <div>{stockData?.createdAt}</div>
                                            </div>

                                            {/* Last Modified By */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Last Modified By
                                                </div>
                                                <div>
                                                    <div>
                                                        {stockData?.modifiedBy || "NA"}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Last Modified Time */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Last Modified Time
                                                </div>
                                                <div>
                                                    {stockData?.lastModifiedTime}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {drawerTab === "stock-instances" && (
                            <div className="tab-panel stock-instances-panel">
                                <div
                                    className="entities-tab"
                                    style={{ padding: 0, paddingTop: "20px" }}
                                >
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <div className="search-box">
                                                <Search size={20} />
                                                <input
                                                    type="text"
                                                    placeholder="Search…"
                                                    value={imeiSearchInput}
                                                    onChange={(e) => {
                                                        setImeiSearchInput(e.target.value);
                                                        setPageInView(1); // reset pagination if needed
                                                    }}
                                                />
                                            </div>
                                            <button
                                                className="icon-btn"
                                                onClick={() => {
                                                    setTempSelectedStock(selectedStock);
                                                    setStockfilterDrawerOpen(true);
                                                }}
                                            >
                                                <Funnel size={18} /> Filter
                                                {selectedStock.length > 0 && (
                                                    <span
                                                        style={{
                                                            background: "#212529",
                                                            color: "#fff",
                                                            borderRadius: "50%",
                                                            fontSize: "12px",
                                                            width: 20,
                                                            height: 20,
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            marginLeft: 6,
                                                        }}
                                                    >
                                                        {selectedStock.length}
                                                    </span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row gy-3 gy-md-0">
                                        <div className="col-md-4 d-flex">
                                            <div
                                                style={{
                                                    border: "1px solid #DEE2E6",
                                                    borderRadius: 8,
                                                    padding: 10,
                                                    textAlign: "right",
                                                    flex: 1,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: "#212529",
                                                        fontFamily:
                                                            "Montserrat, sans-serif",
                                                        lineHeight: "normal",
                                                    }}
                                                >
                                                    Reserved
                                                </p>
                                                <h6
                                                    style={{
                                                        fontSize: 28,
                                                        fontWeight: 600,
                                                        color: "#212529",
                                                        fontFamily:
                                                            "Montserrat, sans-serif",
                                                        lineHeight: "normal",
                                                        marginBottom: 0,
                                                        marginTop: "auto",
                                                    }}
                                                >
                                                    {imeiStats.reserved}
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4 d-flex">
                                            <div
                                                style={{
                                                    border: "1px solid #DEE2E6",
                                                    borderRadius: 8,
                                                    padding: 10,
                                                    textAlign: "right",
                                                    flex: 1,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: "#212529",
                                                        fontFamily:
                                                            "Montserrat, sans-serif",
                                                        lineHeight: "normal",
                                                    }}
                                                >
                                                    Available
                                                </p>
                                                <h6
                                                    style={{
                                                        fontSize: 28,
                                                        fontWeight: 600,
                                                        color: "#212529",
                                                        fontFamily:
                                                            "Montserrat, sans-serif",
                                                        lineHeight: "normal",
                                                        marginBottom: 0,
                                                        marginTop: "auto",
                                                    }}
                                                >
                                                    {imeiStats.available}
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="col-md-4 d-flex">
                                            <div
                                                style={{
                                                    border: "1px solid #DEE2E6",
                                                    borderRadius: 8,
                                                    padding: 10,
                                                    textAlign: "right",
                                                    flex: 1,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: "#212529",
                                                        fontFamily:
                                                            "Montserrat, sans-serif",
                                                        lineHeight: "normal",
                                                    }}
                                                >
                                                    <span style={{ display: "inline-flex", alignItems: "center" }}>Pending<PendingInfoTooltip /></span>
                                                </p>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                    }}
                                                >
                                                    {Object.entries(
                                                        imeiStats.pendingTotals
                                                    ).map(([type, data]) => (
                                                        <div
                                                            key={type}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontSize: 11,
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ marginRight: 6, flexShrink: 0 }}>
                                                                <circle cx="4" cy="4" r="3" fill={data.color} />
                                                            </svg>
                                                            <span
                                                                style={{
                                                                    color: "#6C757D",
                                                                    marginRight: 8,
                                                                }}
                                                            >
                                                                {type}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    marginLeft: "auto",
                                                                    color: "#212529",
                                                                }}
                                                            >
                                                                {data.count}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-wrapper">
                                        <table
                                            className="entities-table"
                                            ref={tableRef}
                                            style={{ minWidth: "unset" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <span>
                                                            IMEI/Barcode{" "}
                                                            <ChevronsUpDown size={10} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Branch{" "}
                                                            <ChevronsUpDown size={10} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Reserved{" "}
                                                            <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Available{" "}
                                                            <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            <span style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>Pending<PendingInfoTooltip /></span>{" "}
                                                            <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th
                                                        className="sticky-action-col"
                                                        style={{ textAlign: "center" }}
                                                    >
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {visibleImeiRows.map((item, idx) => (
                                                    <tr
                                                        key={idx}
                                                        className={
                                                            idx % 2 === 1 ? "striped" : ""
                                                        }
                                                    >
                                                        <td className="py-3">
                                                            <a
                                                                href="#"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="d-flex align-items-center gap-1 me-3"
                                                                style={{
                                                                    color: "#2C7BE5",
                                                                    textDecoration: "underline",
                                                                    fontWeight: "600",
                                                                    fontSize: "12px",
                                                                }}
                                                            >
                                                                {item.imei}
                                                                <SquareArrowOutUpRight
                                                                    size={14}
                                                                    strokeWidth={3}
                                                                />
                                                            </a>
                                                        </td>
                                                        <td className="py-3">
                                                            {item.location}
                                                        </td>
                                                        <td>{item.reserved}</td>
                                                        <td>{item.available}</td>
                                                        <td>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: 4,
                                                                }}
                                                            >
                                                                {item.pending.map((p, i) => (
                                                                    <div
                                                                        key={i}
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            fontSize: 11,
                                                                        }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ marginRight: 6, flexShrink: 0 }}>
                                                                            <circle cx="4" cy="4" r="3" fill={p.color} />
                                                                        </svg>
                                                                        <span
                                                                            style={{
                                                                                color: "#6C757D",
                                                                                marginRight: (p.type === "Outbounding" || p.type === "Outbounding (others)" || p.type === "Transit (Non Reserved)") ? 2 : 8,
                                                                            }}
                                                                        >
                                                                            {p.type}
                                                                        </span>
                                                                                                                                                <span
                                                                            style={{
                                                                                marginLeft: "auto",
                                                                                marginRight: "8px",
                                                                            }}
                                                                        >
                                                                            {p.count}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td>

                                                        <td
                                                            className="sticky-action-col"
                                                            style={{
                                                                textAlign: "center",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <button
                                                                className="icon-btn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setImeiDropdownOpenId(
                                                                        (prevId) =>
                                                                            prevId === item.id
                                                                                ? null
                                                                                : item.id
                                                                    );
                                                                }}
                                                            >
                                                                <MoreHorizontal size={20} />
                                                            </button>

                                                            {imeiDropdownOpenId ===
                                                                item.id && (
                                                                    <div
                                                                        className="backdrop-cls"
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "40px",
                                                                            right: "0",
                                                                            background: "white",
                                                                            boxShadow:
                                                                                "0px 1px 4px 0px #0000001A",
                                                                            zIndex: 1000,
                                                                            minWidth: 152,
                                                                            borderRadius: 8,
                                                                        }}
                                                                        onClick={(e) =>
                                                                            e.stopPropagation()
                                                                        }
                                                                    >
                                                                        <div className="btn-align-forall">
                                                                            <div className="common-for-all">
                                                                                <button className="deactivate-cls">
                                                                                    Stock Out
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {visibleImeiRows.length === 0 && (
                                                    <tr>
                                                        <td
                                                            colSpan="5"
                                                            className="py-3 text-center"
                                                        >
                                                            No results
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                        {drawerTab === "configuration" && (
                            <div style={{ paddingTop: 10 }}>
                                {/* ===== BASIC INFO CARD ===== */}
                                <div
                                    style={{
                                        border: "1px solid #E9ECEF",
                                        borderRadius: 12,
                                        background: "#fff",
                                        marginBottom: 16,
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* Header */}
                                    <div
                                        style={{
                                            background: "#F8F9FA",
                                            padding: "15px 20px",
                                            fontSize: 13,
                                            fontWeight: 600,
                                        }}
                                    >
                                        Basic Info
                                    </div>

                                    {/* Body */}
                                    <div style={{ padding: 16 }}>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                columnGap: 24,
                                                rowGap: 16,
                                                fontSize: 12,
                                            }}
                                        >
                                            {/* Spec Name */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Spec Name
                                                </div>
                                                <div>{stockData?.name}</div>
                                            </div>

                                            {/* SKU Code */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    SKU Code
                                                </div>
                                                <div>{stockData?.sku_code}</div>
                                            </div>

                                            {/* Enable */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Enable
                                                </div>
                                                <span
                                                    style={{
                                                        background: "#D1FADF",
                                                        color: "#027A48",
                                                        padding: "2px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    YES
                                                </span>
                                            </div>

                                            {/* Color */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Color
                                                </div>
                                                <span
                                                    style={{
                                                        background: "#FFE70E",
                                                        padding: "2px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {stockData?.variant?.split(",")[0] ||
                                                        "—"}
                                                </span>
                                            </div>

                                            {/* RAM */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    RAM
                                                </div>
                                                <span
                                                    style={{
                                                        background: "#FFE70E",
                                                        padding: "2px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    8G
                                                </span>
                                            </div>

                                            {/* Storage */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Storage
                                                </div>
                                                <span
                                                    style={{
                                                        background: "#FFE70E",
                                                        padding: "2px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {stockData?.variant
                                                        ?.split(",")[1]
                                                        ?.trim() || "—"}
                                                </span>
                                            </div>

                                            {/* Open ID (FULL WIDTH) */}
                                            <div style={{ gridColumn: "1 / -1" }}>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    Open ID
                                                </div>

                                                <div
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: 6,
                                                        position: "relative",
                                                        maxWidth: "100%",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#2C7BE5",
                                                            cursor: "pointer",
                                                            textDecoration: "underline",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            maxWidth: 420, // ✅ keeps single line
                                                            flexShrink: 1,
                                                        }}
                                                        title={stockData?.openId || "—"}
                                                        onClick={() =>
                                                            // navigator.clipboard.writeText(stockData?.openId)
                                                            navigator.clipboard.writeText(
                                                                stockData?.openId || "—"
                                                            )
                                                        }
                                                    >
                                                        {/* {stockData?.openId} */}
                                                        {stockData?.openId || "—"}
                                                    </span>

                                                    {/* Copy icon + tooltip anchor */}
                                                    <span
                                                        style={{
                                                            position: "relative", // ✅ anchor for tooltip
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            flexShrink: 0,
                                                        }}
                                                        onClick={() => {
                                                            // navigator.clipboard.writeText(stockData?.openId);
                                                            navigator.clipboard.writeText(
                                                                stockData?.openId || "—"
                                                            );
                                                            setCopied(true);
                                                            setTimeout(
                                                                () => setCopied(false),
                                                                1200
                                                            );
                                                        }}
                                                    >
                                                        <Copy
                                                            size={14}
                                                            style={{
                                                                color: "#2C7BE5",
                                                                cursor: "pointer",
                                                            }}
                                                        />

                                                        {copied && (
                                                            <span
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-26px",
                                                                    left: "50%",
                                                                    transform: "translateX(-50%)",
                                                                    background: "#212529",
                                                                    color: "#fff",
                                                                    fontSize: 10,
                                                                    padding: "4px 8px",
                                                                    borderRadius: 6,
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                Copied
                                                            </span>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ===== BUSINESS INFO CARD ===== */}
                                <div
                                    style={{
                                        border: "1px solid #E9ECEF",
                                        borderRadius: 12,
                                        background: "#fff",
                                        overflow: "hidden",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "#F8F9FA",
                                            padding: "10px 16px",
                                            fontSize: 13,
                                            fontWeight: 600,
                                        }}
                                    >
                                        Business Info
                                    </div>

                                    <div style={{ padding: 16 }}>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr",
                                                columnGap: 24,
                                                rowGap: 16,
                                                fontSize: 12,
                                            }}
                                        >
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    GTIN
                                                </div>
                                                <div>8887654109728</div>
                                            </div>

                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    MSRP
                                                </div>
                                                <div>SGD 1,038.00</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {drawerTab === "additional-info" && (
                            <div style={{ paddingTop: 10 }}>
                                {/* ===== BASIC INFO CARD ===== */}
                                <div
                                    style={{
                                        border: "1px solid #E9ECEF",
                                        borderRadius: 12,
                                        background: "#fff",
                                        marginBottom: 16,
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* Header */}
                                    <div
                                        style={{
                                            background: "#F8F9FA",
                                            padding: "10px 16px",
                                            fontSize: 13,
                                            fontWeight: 600,
                                        }}
                                    >
                                        Notes
                                    </div>

                                    {/* Body */}
                                    <div style={{ padding: 16 }}>
                                        <div
                                            style={{
                                                fontSize: 12,
                                            }}
                                        >
                                            {/* Spec Name */}
                                            <div>
                                                <div>
                                                    {stockData?.sku_notes
                                                        ? stockData?.sku_notes
                                                        : "NA"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}


export default StockDrawer;